import './App.css';
import MoviesPage from './components/MoviesPage';

function App() {
    return (
    <>
    <div className="App">
      <MoviesPage/>
    </div>
    </>
  );
}

export default App;
